import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: true,
    gatewayAPI: 'https://api.dev.scf.siemens.cloud/v1',
    scfTemplatesBucketUrl: 'https://files.dev.scf.siemens.cloud',
    sal: {
        url: 'https://scf.dev.sal.siemens.cloud/locations',
        apiKey: 'n8PIlxqfOc38vPfO5Dpd0azN8AnVLbdm1WC8iO3V'
    },
    msalConfig: {
        auth: {
            clientId: 'b78a8420-98e7-4037-9657-710d57ce9bca',
            authority: 'https://login.microsoftonline.com/38ae3bcd-9579-4fd4-adda-b42e1495d55a',
            redirectUri: `${window.location.origin}/home`,
            postLogoutRedirectUri: window.location.origin,
            navigateToLoginRequestUrl: true
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage,
            storeAuthStateInCookie: false
        },
        system: {
            allowPlatformBroker: false
        }
    },
    apiConfig: [
        {
            scopes: ['https://api.dev.scf.siemens.cloud/App.Access'],
            uri: 'https://api.dev.scf.siemens.cloud/v1'
        },
        {
            scopes: ['https://api.dev.scf.siemens.cloud/App.Access'],
            uri: 'https://files.dev.scf.siemens.cloud'
        },
        {
            scopes: ['https://api.dev.sal.siemens.cloud/SAL.Read'],
            uri: 'https://scf.dev.sal.siemens.cloud'
        },
        {
            scopes: ['User.ReadBasic.All', 'User.Read', 'Contacts.Read'],
            uri: 'https://graph.microsoft.com/v1.0'
        }
    ]
};
